import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchBrandList = createAsyncThunk("fetchBrandList", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({ page, size: limit, keyword: filters?.keyword ?? "" });
	const response = await axiosHttp.get(`assets/brands?${params}`);
	const data = response.data?.data ?? response.data;
	return { docs: data.content ?? [], total: data.total, page: data.page };
});

const BrandListSlice = createSlice({
	name: "brandListSlice",
	initialState: { isLoading: false, data: null, error: null, page: 1, total: 0 },
	extraReducers: (builder) => {
		builder.addCase(fetchBrandList.pending, (state) => { state.isLoading = true; });
		builder.addCase(fetchBrandList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchBrandList.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
	},
});

export default BrandListSlice.reducer;
